






















































import { Component, Prop, Mixins } from "vue-property-decorator";
import { OtherCert } from "@/types/ewelluser";
import FileUpload from "#/components/FileUpload.vue";
import DateInput from "#/components/DateInput.vue";
import RulesMixin from "#/mixins/rulesMixin";

@Component({ components: { FileUpload, DateInput } })
export default class OtherCertifications extends Mixins(RulesMixin) {
  /** その他資格区分 */
  @Prop() private readonly value!: OtherCert[];

  /** その他資格区分 */
  private get OtherCerts() {
    return this.value;
  }

  private addOtherCert() {
    this.value.push({
      id: 0,
      ewell_user_id: 0,
      regist_name: "",
      regist_yearmonth: ""
    });
  }
}
